import type { StoreActionApi } from 'react-sweet-state';
import type { RouterActionsType } from '@atlassian/jira-router';
import type { State } from '../../types';
import { getDraftEditUrl } from '../../utils';

export const navigateCreateDraftRoute =
	({
		routerActions,
		projectKey,
		selectedSpaceKey,
	}: {
		routerActions: RouterActionsType;
		projectKey: string;
		selectedSpaceKey: string;
	}) =>
	async ({ getState }: StoreActionApi<State>) => {
		const { articleId, draftShareId } = { ...getState() };
		const EDIT_DRAFT_ROUTE = getDraftEditUrl(projectKey, selectedSpaceKey, articleId, draftShareId);
		routerActions.push(EDIT_DRAFT_ROUTE);
	};
